import React, { memo, useEffect, useLayoutEffect, useRef } from 'react';
import { Group, Mesh } from 'three';
import { useDataStore } from '../../zustand';
import { useGetPlacementSceneContent } from './trackerGroupHooks';
import { useGetCurrentSceneId } from '@/hooks/general';

interface IPlacementSceneProps {
	sceneId: string;
	visible?: boolean;
}
const PlacementScene: React.FunctionComponent<IPlacementSceneProps> = ({ sceneId }) => {
	const groupRef = useRef<Group>(null);
	const currentSceneId = useGetCurrentSceneId();
	const componentsById = useDataStore((state) => state.componentsById);
	const sceneContent = useGetPlacementSceneContent(sceneId, componentsById, false);

	useEffect(() => {
		setTimeout(() => {
			groupRef.current?.traverse((node: any) => {
				if (node.isMesh) {
					const mesh = node as Mesh;
					const material = mesh.material;
					if (Array.isArray(material)) {
						material.forEach(m => {
							m.transparent = true;
							m.opacity = m.opacity * 0.7
							if (!m.transparent) {
								m.transparent = true;
								m.needsUpdate = true;
							}
						})
					} else {
						material.opacity = material.opacity * 0.7;
						if (!material.transparent) {
							material.transparent = true;
							material.needsUpdate = true;
						}
					}
				}
			});
		}, 50)
		
	}, []);

	return (
		<group ref={groupRef} name="placement_scene" visible={currentSceneId === sceneId}>
			{sceneContent}
		</group>
	);
};

PlacementScene.displayName = 'PlacementScene';
export default memo(PlacementScene);
